'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function(createHTML){
  return function sup(){
    return createHTML(this, 'sup', '', '');
  }
});


// WEBPACK FOOTER //
// ./~/core-js/modules/es6.string.sup.js